import { client } from '@/client';

let detailController, stepController;

// 取消detail请求
export const abortRecordDetailRequest = () => {
  if (detailController) {
    detailController.abort();
  }
};

// 取消step请求
export const abortRecordStepRequest = () => {
  if (stepController) {
    stepController.abort();
  }
};

// 查询执行结果列表
export function queryRecordList(params) {
  return client.post('/api/exec_log_service/page-query', params);
}

// 获取执行结果详情
export function getRecordDetail(params) {
  detailController = new AbortController();
  const request = client.post('/api/exec_log_service/detail', params, {
    signal: detailController.signal,
  });
  return request;
}

// 获取执行结果概要
export function getRecordBasic(params) {
  stepController = new AbortController();
  return client.post('/api/exec_log_service/step', params, {
    signal: stepController.signal,
  });
}

// 发送执行指令
export function sendExecOperate(params) {
  return client.post('/api/exec_log_service/operation', params);
}
